import * as React from "react";
import { Suspense } from "react";
import ReactDOM from "react-dom";

import Header from '../shared/components/Header/Header';
import Footer from '../shared/components/Footer/Footer';

const Shop = React.lazy(() => import(/* webpackChunkName: "SHOP" */ '../shared/pages/Shop/Shop'));
const NotFound = React.lazy(() => import(/* webpackChunkName: "NOT_FOUND" */ '../shared/pages/NotFound/NotFound'));
const Refunds = React.lazy(() => import(/* webpackChunkName: "REFUNDS" */ '../shared/pages/Refunds/Refunds'));
const Product = React.lazy(() => import(/* webpackChunkName: "PRODUCT" */ '../shared/pages/Product/Product'));
const Checkout = React.lazy(() => import(/* webpackChunkName: "CHECKOUT" */ '../shared/pages/Checkout/Checkout'));
const Terms = React.lazy(() => import(/* webpackChunkName: "TERMS" */ '../shared/pages/Terms/Terms'));

const routes = {
    "SHOP": <Shop props={window.__INITIAL_DATA__} />,
    "NOT_FOUND": <NotFound props={window.__INITIAL_DATA__} />,
    "REFUNDS": <Refunds props={window.__INITIAL_DATA__} />,
    "PRODUCT": <Product props={window.__INITIAL_DATA__} />,
    "CHECKOUT": <Checkout props={window.__INITIAL_DATA__} />,
    "TERMS": <Terms props={window.__INITIAL_DATA__} />,
}

ReactDOM.render(
<Suspense fallback={<><Header/><div style={{height: "100vh"}}></div><Footer/></>}>
    <Header/>
        {routes[window.__ROUTE__]}
    <Footer/>
</Suspense>, document.getElementById("app"));